/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Why_It_MattersInputs */

const en_directory_hubs_signals_why_it_matters = /** @type {(inputs: Directory_Hubs_Signals_Why_It_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why it matters`)
};

const zh_directory_hubs_signals_why_it_matters = /** @type {(inputs: Directory_Hubs_Signals_Why_It_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么重要`)
};

/**
* | output |
* | --- |
* | "Why it matters" |
*
* @param {Directory_Hubs_Signals_Why_It_MattersInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_why_it_matters = /** @type {((inputs?: Directory_Hubs_Signals_Why_It_MattersInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Why_It_MattersInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_why_it_matters(inputs)
	return zh_directory_hubs_signals_why_it_matters(inputs)
});
export { directory_hubs_signals_why_it_matters as "directory.hubs.signals.why_it_matters" }